import PropTypes from 'prop-types';
import React from 'react';
import {home} from 'src/shared/pagePaths';
import {
  button,
  buttonGroup,
  primary,
} from 'src/styles/modules/button.module.scss';
import XfinityAssistantIcon from 'src/svgs/XA_transparent.svg';
import {header} from '../header.module.scss';
import {text, customBreakLine} from './style.module.scss';

export const UnavailableView = ({
  availableIntents,
  onGoToSupport,
  onLaunchXfinityAssistant,
  selectedIntent,
}) => {
  const matchedIntent = availableIntents.find(intent => intent.value === selectedIntent);

  return (
    <>
      <header className={header}>
        <XfinityAssistantIcon />
        <h1 className={text}>The Xfinity Assistant can answer most questions <br className={customBreakLine} />and connect you with a chat agent if needed.
        </h1>
        <p>{matchedIntent?.subtitle} callback is not currently available. We apologize for the inconvenience.</p>
      </header>
      <div className={buttonGroup}>
        <button className={`${button} ${primary}`} onClick={() => onLaunchXfinityAssistant(matchedIntent?.intent)}>Chat with Xfinity</button>
        <a className={button} onClick={onGoToSupport} href={home()}>Go to Support</a>
      </div>
    </>
  );
};

UnavailableView.propTypes = {
  availableIntents: PropTypes.array.isRequired,
  onGoToSupport: PropTypes.func.isRequired,
  onLaunchXfinityAssistant: PropTypes.func.isRequired,
  selectedIntent: PropTypes.string.isRequired,
};
